var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 53,
    viewBox: "0 0 136 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2282 7.28643C44.1946 7.28643 45.7886 5.65533 45.7886 3.64322C45.7886 1.6311 44.1946 0 42.2282 0C40.2619 0 38.6678 1.6311 38.6678 3.64322C38.6678 4.4882 38.9489 5.26607 39.4206 5.884L34.801 12.1469L40.6136 12.1717L42.1883 7.28627C42.2016 7.28627 42.2149 7.28643 42.2282 7.28643Z",
    fill: "url(#paint0_radial_12_9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1017 7.28643C8.13531 7.28643 6.54126 5.65533 6.54126 3.64322C6.54126 1.6311 8.13531 0 10.1017 0C12.068 0 13.6621 1.6311 13.6621 3.64322C13.6621 4.4882 13.381 5.26607 12.9093 5.884L17.5289 12.1469L11.7163 12.1717L10.1416 7.28627C10.1283 7.28627 10.115 7.28643 10.1017 7.28643Z",
    fill: "url(#paint1_radial_12_9)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.9491C0 15.2787 4.5968 10.6819 10.2672 10.6819H42.0626C47.733 10.6819 52.3298 15.2787 52.3298 20.9491V35.3564C52.3298 41.0268 47.733 45.6236 42.0626 45.6236H10.2672C4.5968 45.6236 0 41.0268 0 35.3564V20.9491Z",
    fill: "url(#paint2_radial_12_9)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63043 24.7579C5.63043 19.7734 9.67116 15.7327 14.6557 15.7327H37.6742C42.6587 15.7327 46.6994 19.7734 46.6994 24.7579V31.5476C46.6994 36.5321 42.6587 40.5728 37.6742 40.5728H14.6557C9.67116 40.5728 5.63043 36.5321 5.63043 31.5476V24.7579Z",
    fill: "url(#paint3_linear_12_9)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4837 28.1528C15.4837 26.1407 17.1148 24.5095 19.1269 24.5095H33.2858C35.2978 24.5095 36.929 26.1407 36.929 28.1528C36.929 30.1649 35.2978 31.796 33.2858 31.796H19.1269C17.1148 31.796 15.4837 30.1649 15.4837 28.1528Z",
    fill: "#22A6DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.77 28.1522C22.77 30.1186 21.1759 31.7126 19.2096 31.7126C17.2432 31.7126 15.6492 30.1186 15.6492 28.1522C15.6492 26.1858 17.2432 24.5918 19.2096 24.5918C21.1759 24.5918 22.77 26.1858 22.77 28.1522Z",
    fill: "#176A96"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7633 28.1522C36.7633 30.1186 35.1692 31.7126 33.2028 31.7126C31.2365 31.7126 29.6424 30.1186 29.6424 28.1522C29.6424 26.1858 31.2365 24.5918 33.2028 24.5918C35.1692 24.5918 36.7633 26.1858 36.7633 28.1522Z",
    fill: "#176A96"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1137 27.0756C34.1137 27.853 33.4835 28.4832 32.7061 28.4832C31.9287 28.4832 31.2985 27.853 31.2985 27.0756C31.2985 26.2982 31.9287 25.668 32.7061 25.668C33.4835 25.668 34.1137 26.2982 34.1137 27.0756Z",
    fill: "#CDDCF2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2988 27.0756C18.2988 27.853 18.929 28.4832 19.7064 28.4832C20.4838 28.4832 21.114 27.853 21.114 27.0756C21.114 26.2982 20.4838 25.668 19.7064 25.668C18.929 25.668 18.2988 26.2982 18.2988 27.0756Z",
    fill: "#CDDCF2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1266 46.2031H20.2029C20.0228 46.2031 19.9344 46.4225 20.0642 46.5473L25.4716 51.7467C25.8587 52.1189 26.4707 52.1189 26.8578 51.7467L32.2652 46.5473C32.395 46.4225 32.3067 46.2031 32.1266 46.2031Z",
    fill: "url(#paint4_linear_12_9)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hue"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2282 7.28643C44.1945 7.28643 45.7886 5.65533 45.7886 3.64322C45.7886 1.6311 44.1945 0 42.2282 0C40.2618 0 38.6678 1.6311 38.6678 3.64322C38.6678 3.7304 38.6708 3.81687 38.6766 3.90253C38.7639 5.17164 38.9013 6.58802 38.1462 7.61175L37.3169 8.73598C36.2716 10.1532 37.2784 12.1575 39.0394 12.165V12.165C39.9768 12.1689 40.8089 11.5656 41.0965 10.6734L42.176 7.3243C42.1833 7.30164 42.2044 7.28643 42.2282 7.28643V7.28643Z",
    fill: "url(#paint5_radial_12_9)",
    fillOpacity: 0.73
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1016 7.28643C8.13528 7.28643 6.54123 5.65533 6.54123 3.64322C6.54123 1.6311 8.13528 0 10.1016 0C12.068 0 13.6621 1.6311 13.6621 3.64322C13.6621 3.7304 13.6591 3.81687 13.6532 3.90253C13.566 5.17164 13.4285 6.58802 14.1837 7.61175L15.0129 8.73598C16.0583 10.1532 15.0515 12.1575 13.2904 12.165V12.165C12.353 12.1689 11.5209 11.5656 11.2333 10.6733L10.1539 7.3243C10.1466 7.30164 10.1255 7.28643 10.1016 7.28643V7.28643Z",
    fill: "url(#paint6_radial_12_9)",
    fillOpacity: 0.73
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.9491C0 15.2787 4.5968 10.6819 10.2672 10.6819H42.0626C47.733 10.6819 52.3298 15.2787 52.3298 20.9491V35.3564C52.3298 41.0268 47.733 45.6236 42.0626 45.6236H10.2672C4.5968 45.6236 0 41.0268 0 35.3564V20.9491Z",
    fill: "url(#paint7_radial_12_9)",
    fillOpacity: 0.73
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63043 24.7579C5.63043 19.7734 9.67116 15.7327 14.6557 15.7327H37.6742C42.6587 15.7327 46.6994 19.7734 46.6994 24.7579V31.5476C46.6994 36.5321 42.6587 40.5728 37.6742 40.5728H14.6557C9.67116 40.5728 5.63043 36.5321 5.63043 31.5476V24.7579Z",
    fill: "url(#paint8_radial_12_9)",
    fillOpacity: 0.73
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4837 28.1528C15.4837 26.1407 17.1148 24.5095 19.1269 24.5095H33.2858C35.2978 24.5095 36.929 26.1407 36.929 28.1528C36.929 30.1648 35.2978 31.796 33.2858 31.796H19.1269C17.1148 31.796 15.4837 30.1648 15.4837 28.1528Z",
    fill: "url(#paint9_radial_12_9)",
    fillOpacity: 0.73
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.77 28.1522C22.77 30.1186 21.1759 31.7126 19.2096 31.7126C17.2432 31.7126 15.6492 30.1186 15.6492 28.1522C15.6492 26.1858 17.2432 24.5918 19.2096 24.5918C21.1759 24.5918 22.77 26.1858 22.77 28.1522Z",
    fill: "url(#paint10_radial_12_9)",
    fillOpacity: 0.73
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7633 28.1522C36.7633 30.1186 35.1692 31.7126 33.2028 31.7126C31.2365 31.7126 29.6424 30.1186 29.6424 28.1522C29.6424 26.1858 31.2365 24.5918 33.2028 24.5918C35.1692 24.5918 36.7633 26.1858 36.7633 28.1522Z",
    fill: "url(#paint11_radial_12_9)",
    fillOpacity: 0.73
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1137 27.0755C34.1137 27.8529 33.4835 28.4831 32.7061 28.4831C31.9287 28.4831 31.2985 27.8529 31.2985 27.0755C31.2985 26.2981 31.9287 25.6679 32.7061 25.6679C33.4835 25.6679 34.1137 26.2981 34.1137 27.0755Z",
    fill: "url(#paint12_radial_12_9)",
    fillOpacity: 0.73
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2988 27.0755C18.2988 27.8529 18.929 28.4831 19.7064 28.4831C20.4838 28.4831 21.114 27.8529 21.114 27.0755C21.114 26.2981 20.4838 25.6679 19.7064 25.6679C18.929 25.6679 18.2988 26.2981 18.2988 27.0755Z",
    fill: "url(#paint13_radial_12_9)",
    fillOpacity: 0.73
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1266 46.2031H20.2029C20.0228 46.2031 19.9344 46.4225 20.0642 46.5473L25.4716 51.7467C25.8587 52.1189 26.4707 52.1189 26.8578 51.7467L32.2652 46.5473C32.395 46.4225 32.3067 46.2031 32.1266 46.2031Z",
    fill: "url(#paint14_radial_12_9)",
    fillOpacity: 0.73
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6866 33.9066C70.4519 33.9066 70.2759 33.848 70.1586 33.7306C70.0413 33.5986 69.9753 33.4446 69.9606 33.2686L68.3326 19.1006C68.3179 18.91 68.3619 18.7633 68.4646 18.6606C68.5673 18.558 68.6993 18.5066 68.8606 18.5066H71.1046C71.3246 18.5066 71.4786 18.5653 71.5666 18.6826C71.6693 18.8 71.7279 18.9173 71.7426 19.0346L72.8866 29.7926L78.5846 19.0346C78.6286 18.9173 78.7166 18.8 78.8486 18.6826C78.9953 18.5653 79.1786 18.5066 79.3986 18.5066H81.9286C82.1046 18.5066 82.2146 18.58 82.2586 18.7266C82.3173 18.8586 82.3026 19.0053 82.2146 19.1666L74.6246 33.2686C74.5366 33.4446 74.4119 33.5986 74.2506 33.7306C74.0893 33.848 73.8839 33.9066 73.6346 33.9066H70.6866Z",
    fill: "#D1C8F4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5116 33.9066C82.3916 33.9066 82.2956 33.8646 82.2236 33.7806C82.1516 33.6966 82.1276 33.5886 82.1516 33.4566L83.9516 24.9966C83.9756 24.8646 84.0416 24.7566 84.1496 24.6726C84.2576 24.5886 84.3716 24.5466 84.4916 24.5466H86.2916C86.4236 24.5466 86.5196 24.5886 86.5796 24.6726C86.6396 24.7566 86.6576 24.8646 86.6336 24.9966L84.8336 33.4566C84.8096 33.5886 84.7496 33.6966 84.6536 33.7806C84.5576 33.8646 84.4436 33.9066 84.3116 33.9066H82.5116ZM84.7616 23.1066C84.6296 23.1066 84.5276 23.0646 84.4556 22.9806C84.3956 22.8966 84.3776 22.7886 84.4016 22.6566L84.7076 21.2166C84.7316 21.0846 84.7916 20.9766 84.8876 20.8926C84.9956 20.7966 85.1156 20.7486 85.2476 20.7486H87.1376C87.2696 20.7486 87.3656 20.7966 87.4256 20.8926C87.4976 20.9766 87.5216 21.0846 87.4976 21.2166L87.1736 22.6566C87.1616 22.7886 87.1016 22.8966 86.9936 22.9806C86.8856 23.0646 86.7716 23.1066 86.6516 23.1066H84.7616Z",
    fill: "#D1C8F4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8107 33.9066C88.664 33.9066 88.5467 33.8553 88.4587 33.7526C88.3707 33.65 88.3413 33.518 88.3707 33.3566L91.4067 19.0566C91.436 18.8953 91.5167 18.7633 91.6487 18.6606C91.7807 18.558 91.92 18.5066 92.0667 18.5066H98.3807C99.5247 18.5066 100.463 18.6826 101.197 19.0346C101.945 19.3866 102.473 19.8853 102.781 20.5306C103.103 21.176 103.169 21.9313 102.979 22.7966C102.861 23.3686 102.656 23.86 102.363 24.2706C102.084 24.6813 101.776 25.0186 101.439 25.2826C101.101 25.532 100.786 25.7153 100.493 25.8326C101.006 26.126 101.417 26.5733 101.725 27.1746C102.033 27.7613 102.099 28.4726 101.923 29.3086C101.717 30.2326 101.365 31.0393 100.867 31.7286C100.383 32.418 99.7227 32.9533 98.8867 33.3346C98.0507 33.716 97.0167 33.9066 95.7847 33.9066H88.8107ZM92.3087 31.3326H95.6747C96.364 31.3326 96.9433 31.1346 97.4127 30.7386C97.882 30.328 98.1753 29.844 98.2927 29.2866C98.4247 28.7146 98.3587 28.238 98.0947 27.8566C97.8453 27.4606 97.332 27.2626 96.5547 27.2626H93.1667L92.3087 31.3326ZM93.6947 24.7326H96.8187C97.4933 24.7326 98.0507 24.564 98.4907 24.2266C98.9307 23.8746 99.2167 23.4273 99.3487 22.8846C99.466 22.342 99.4 21.9093 99.1507 21.5866C98.9013 21.2493 98.4393 21.0806 97.7647 21.0806H94.4867L93.6947 24.7326Z",
    fill: "#D1C8F4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M110.937 34.1266C110.028 34.1266 109.184 34.002 108.407 33.7526C107.644 33.5033 106.999 33.1293 106.471 32.6306C105.958 32.132 105.591 31.5086 105.371 30.7606C105.166 30.0126 105.151 29.1326 105.327 28.1206C105.43 27.49 105.547 26.8666 105.679 26.2506C105.826 25.62 105.972 24.982 106.119 24.3366C106.603 22.3566 107.468 20.8533 108.715 19.8266C109.976 18.8 111.641 18.2866 113.709 18.2866C114.618 18.2866 115.454 18.4186 116.217 18.6826C116.98 18.932 117.625 19.3133 118.153 19.8266C118.681 20.34 119.048 20.9706 119.253 21.7186C119.473 22.4666 119.495 23.3393 119.319 24.3366C119.202 24.982 119.077 25.62 118.945 26.2506C118.813 26.8666 118.666 27.49 118.505 28.1206C118.006 30.1446 117.134 31.6553 115.887 32.6526C114.64 33.6353 112.99 34.1266 110.937 34.1266ZM111.179 31.2886C112.059 31.2886 112.836 31.032 113.511 30.5186C114.186 29.9906 114.655 29.1546 114.919 28.0106C115.08 27.3653 115.22 26.764 115.337 26.2066C115.469 25.6346 115.586 25.0333 115.689 24.4026C115.909 23.2586 115.814 22.43 115.403 21.9166C115.007 21.3886 114.362 21.1246 113.467 21.1246C112.572 21.1246 111.795 21.3886 111.135 21.9166C110.475 22.43 110.006 23.2586 109.727 24.4026C109.566 25.0333 109.426 25.6346 109.309 26.2066C109.192 26.764 109.074 27.3653 108.957 28.0106C108.752 29.1546 108.84 29.9906 109.221 30.5186C109.617 31.032 110.27 31.2886 111.179 31.2886Z",
    fill: "#D1C8F4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M124.942 33.9066C124.795 33.9066 124.678 33.8553 124.59 33.7526C124.502 33.65 124.472 33.518 124.502 33.3566L127.032 21.5646H123.028C122.881 21.5646 122.764 21.5133 122.676 21.4106C122.588 21.308 122.558 21.1833 122.588 21.0366L123.006 19.0566C123.035 18.8953 123.108 18.7633 123.226 18.6606C123.358 18.558 123.504 18.5066 123.666 18.5066H135.194C135.355 18.5066 135.472 18.558 135.546 18.6606C135.634 18.7633 135.663 18.8953 135.634 19.0566L135.194 21.0366C135.164 21.1833 135.091 21.308 134.974 21.4106C134.856 21.5133 134.717 21.5646 134.556 21.5646H130.574L128.044 33.3566C128.014 33.518 127.934 33.65 127.802 33.7526C127.684 33.8553 127.545 33.9066 127.384 33.9066H124.942Z",
    fill: "#D1C8F4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.4197 3.35342) rotate(89.5304) scale(10.102 37.558)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.131842,
    stopColor: "#9AF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412744,
    stopColor: "#30BFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861466,
    stopColor: "#1A80BB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_12_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.4197 3.35342) rotate(89.5304) scale(10.102 37.558)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.131842,
    stopColor: "#9AF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412744,
    stopColor: "#30BFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861466,
    stopColor: "#1A80BB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_12_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5917 13.0774) rotate(90.2334) scale(30.1509 45.155)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37DAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312467,
    stopColor: "#30BFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A80BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12_9",
    x1: 25.1099,
    y1: 10.6236,
    x2: 25.4604,
    y2: 47.0739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25B8D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312467,
    stopColor: "#259DC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175A9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12_9",
    x1: 25.8749,
    y1: 44.3815,
    x2: 25.9379,
    y2: 50.8401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25B8D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312467,
    stopColor: "#259DC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175A9C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_12_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.3223 12.5) rotate(84.4472) scale(39.7122 76.6175)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538934,
    stopColor: "#28215B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2555"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_12_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.3223 12.5) rotate(84.4472) scale(39.7122 76.6175)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538934,
    stopColor: "#28215B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2555"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_12_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.3223 12.5) rotate(84.4472) scale(39.7122 76.6175)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538934,
    stopColor: "#28215B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2555"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_12_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.3223 12.5) rotate(84.4472) scale(39.7122 76.6175)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538934,
    stopColor: "#28215B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2555"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_12_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.3223 12.5) rotate(84.4472) scale(39.7122 76.6175)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538934,
    stopColor: "#28215B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2555"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_12_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.3223 12.5) rotate(84.4472) scale(39.7122 76.6175)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538934,
    stopColor: "#28215B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2555"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_12_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.3223 12.5) rotate(84.4472) scale(39.7122 76.6175)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538934,
    stopColor: "#28215B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2555"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_12_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.3223 12.5) rotate(84.4472) scale(39.7122 76.6175)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538934,
    stopColor: "#28215B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2555"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_12_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.3223 12.5) rotate(84.4472) scale(39.7122 76.6175)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538934,
    stopColor: "#28215B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2555"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_12_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.3223 12.5) rotate(84.4472) scale(39.7122 76.6175)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538934,
    stopColor: "#28215B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2555"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.bb7d844158a023d70f6f9c7406249d89.svg";
export { ForwardRef as ReactComponent };